import React, { useEffect, useState } from "react";
import { useAuth } from "../../auth/FirebaseAuth.js";

import Space from "../../layout/Space.js";

import PrimaryButton from "../../buttons/PrimaryButton.js";
import { useSnackbar } from "notistack";
import createNewFolder from "../../api/create/createNewFolder.js";
import { DatePicker, Spin, TimePicker } from "antd";
import SmallSpinner from "../../loading/SmallSpinner.js";
import { Skeleton } from "@mui/material";
import SecondaryButton from "../../buttons/SecondaryButton.js";
import {
  getDateFromFlutter,
  getDocDataById,
  getDocDataByRef,
  getRefFromId,
  queryCollection,
} from "../../models/DataFunctions.js";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken.js";
import { useAppContext } from "../../config/AppContext.js";
import { use } from "echarts";
import { useTheme } from "@mui/material";

import { ConfigProvider } from "antd";
import frFR from "antd/locale/fr_FR";
import "moment/locale/fr";

import "moment/locale/fr";

import locale from "antd/locale/fr_FR";
import dayjs from "dayjs";
import DropDownGPT1 from "../../dropdowns/DropDownGPT1.js";
import TextField2 from "../../textfields/TextField2.js";
import updateDocDataFieldApi from "../../api/database/updateDocDataFieldApi.js";
import DropDownGPT0 from "../../dropdowns/DropDownGTP0.js";
import {
  EasySwitch,
  ToggleLogementBrick,
  ToggleSettingsBrick,
} from "../../textfields/EasySwitch.js";
import TextField2T from "../../textfields/TextField2T.js";
import DropDownGPT03 from "../../dropdowns/DropDownGTP03.js";
import DropDownGPTS3 from "../../dropdowns/DropDownGPTS3.js";
import DatePickerGPT0 from "../../textfields/DatePickerGPT0.js";
import Gleap from "gleap";
import addClientPartners from "../../api/add/addClientPartners.js";
import { firstPlan, isOnlyBasic } from "../../hexagone/VisibilityHelpers.js";
import { getCommunWorkspace } from "./FolderHelpers.js";
import { folder } from "jszip";
import DropDownGPTM3 from "../../dropdowns/DropDownGPTM3.js";
import { getOrgById } from "../../models/OrgFunctions.js";
import { fetchPostalCodesApi } from "../../api/google_places/GooglePlacesApi.js";
import { checkAndSendTriggerEvent } from "../../config/TriggerEmailSystem.js";

function NewFolder({ userData, orgData, navigateWorkspace, masterData }) {
  const { currentUser, loading } = useAuth();

  const intervention_options = [
    { value: false, label: "Intervention à venir" },
    { value: true, label: "Intervention réalisée" },
  ];

  const searchParams = new URLSearchParams(window.location.search);
  const param_duplicate_folder_id =
    searchParams.get("duplicate_folder_id") || null;

  const param_ville = searchParams.get("ville") || "";
  const param_postal = searchParams.get("postal") || "";
  const param_adresse = searchParams.get("adresse") || "";

  const param_name = searchParams.get("name") || "";
  const param_client = searchParams.get("client") || "";
  const param_pack_id = searchParams.get("pack_id") || null;
  const param_members = searchParams.get("members") || "";
  const param_conductor = searchParams.get("conductor") || null;
  const param_start = searchParams.get("start") || "";
  const param_event_id = searchParams.get("eventid") || "";

  const [step, setStep] = useState(0);
  const [folderData, setFolderData] = useState(null);

  const [clients, setClients] = useState([]);
  const [clients_name_options, setClients_options] = useState([]);
  const [pack_options, setPack_options] = useState([]);

  const [client_conductors, setClient_conductors] = useState([]);
  const [structure_options, setStructure_options] = useState([
    { value: "maison_individuelle", label: "Maison individuelle" },
    {
      value: "maisons_individuelles_groupees",
      label: "Maisons individuelles groupées",
    },
    { value: "extension", label: "Extension" },
    { value: "collectif", label: "Collectif" },
    { value: "tertiaire", label: "Tertiaire" },
  ]);
  const [collectif_options, setCollectif_options] = useState([
    { value: "infiltrometrie", label: "Infiltrométrie" },
    { value: "ventilation", label: "Ventilation" },
    { value: "acoustique", label: "Acoustique" },
    { value: "promevent", label: "Promevent" },

    { value: "dpe", label: "DPE" },
  ]);
  const [collectif_options_selected, setCollectifOptionsSelected] = useState(
    []
  );

  const [structure, setStructure] = useState(structure_options[0].value);
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  // State variables to store the input values
  const [nom, setNom] = useState(param_name);
  const [prenom, setPrenom] = useState("");
  const [num, setNum] = useState("");
  const [ville, setVille] = useState(param_ville);
  const [postal, setPostal] = useState(param_postal);
  const [adresse, setAdresse] = useState(param_adresse);
  const [intervention, setIntervention] = useState(
    intervention_options[0].value
  );
  const [client_text_value, setClientTextValue] = useState(param_client);
  const [client, setClient] = useState(param_client);

  const [audit_config, setAuditConfig] = useState({});
  const [mission, setMission] = useState(param_pack_id);
  const [conductor, setConductor] = useState(param_conductor);

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [marque, setMarque] = useState(null);
  const [marques_options, setMarques_options] = useState([]);
  const [payment_allowed, setPaymentAllowed] = useState(false);
  const [use_facture_mat, setUseFactureMat] = useState(false);

  const handleFetchClientConductors = async (value, early_clients = null) => {
    setClientTextValue(value);
    if (value === null) {
      setClient(null);
      return;
    }
    let all_clients = clients;
    if (early_clients) {
      all_clients = early_clients;
    }
    if (currentUser) {
      try {
        const client = all_clients.find((client) => client.id === value);
        if (!client) {
          return;
        }
        setClient(value);
        if (client.marques) {
          setMarque(client.marques[0].name);
        }
        const filters = [
          { field: "org_id", operator: "==", value: client.id },
          { field: "role", operator: "==", value: "conductor" },
        ];
        const conductors = (await queryCollection("user", filters)) || [];
        const client_conductors = conductors.map((client) => {
          return { value: client.id, label: client.display_name };
        });
        if (client.marques && client.marques.length > 0) {
          const marques_options = client.marques.map((marque) => {
            return { value: marque.name, label: marque.name };
          });
          setMarques_options(marques_options);
        } else {
          setMarques_options([]);
        }

        setClient_conductors(client_conductors);
        let clientWorkspace = await getCommunWorkspace(client, orgData);
        setPaymentAllowed(clientWorkspace?.permissions?.payment_allowed);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  const [citiesName, setCitiesName] = useState([]);
  const [postalCodes, setPostalCodes] = useState([]);
  const [postalCodesItems, setPostalCodesItems] = useState([]);
  const [loadingSearch, setLoadingSearch] = useState(false);

  const fetchPostalCodes = async (city, exact_match = false) => {
    await fetchPostalCodesApi(
      setCitiesName,
      setPostalCodes,
      setPostal,
      setLoadingSearch,
      prefix,
      city,
      exact_match,
      postal
    );
  };

  const updatePostalCodesItems = (currentPostalValue) => {
    // Always include the current postal value if it exists
    const codes = [...postalCodes];
    if (currentPostalValue && !codes.includes(currentPostalValue)) {
      codes.unshift(currentPostalValue);
    }
    console.log(codes);
    setPostalCodesItems(codes.map((code) => ({
      value: code,
      label: code,
    })));
  };

  // Update postal codes items when postalCodes array changes
  useEffect(() => {
    updatePostalCodesItems(postal);
  }, [postalCodes]);

  // default state should be param_start wich is a dd/MM/yyyy string

  const [selectedDateSeconds, setSelectedDateSeconds] = useState(
    param_start ? dayjs(param_start, "DD/MM/YYYY").unix() : null
  );
  const [selectedTime, setSelectedTime] = useState(null);

  const [loadingData, setLoadingData] = useState(false);
  const [notify_folder_open, setNotifyFolderOpen] = useState(false);
  const [email_open, setEmailOpen] = useState(false);
  const [add_client_experts_open, setClientExpertsOpen] = useState(false);

  const [type_client, setTypeClient] = useState(param_client ? "pro" : null);
  const [folder_type, setFolderType] = useState(
    isOnlyBasic(masterData) ? "basic" : firstPlan(masterData)
  );
  const [particulier_email, setParticulierEmail] = useState("");
  const [particulier_phone, setParticulierPhone] = useState("");

  const [addCarnet, setAddCarnet] = useState(false);
  // Fetch user, org, clients, and article data
  const handleFetchData = async () => {
    if (currentUser) {
      try {
        const starttime = new Date();
        // Fetch user data

        // Fetch organization data using user's org reference

        const filters = [
          {
            field: "masters_id",
            operator: "array-contains",
            value: userData.org_id,
          },
        ];
        let clients = await queryCollection("org", filters);
        clients.filter((client) => {
          return !["infiltro", "expert"].includes(client.partner_type);
        });

        const clients_name = clients.map((client) => {
          return { value: client.id, label: client.name };
        });
        const ordered_clients = clients_name.sort((a, b) =>
          a.label.localeCompare(b.label)
        );

        if (client) {
          handleFetchClientConductors(client);
        }

        if (
          param_client &&
          clients.find((client) => client.id === param_client)
        ) {
          handleFetchClientConductors(
            param_client,

            clients
          );
        }

        setClients(clients);
        setClients_options(ordered_clients);

        let first_plan = firstPlan(masterData);
        await handleFetchPacksBasedOnFolderType(
          setPack_options,
          masterData,

          setMission
        );

        if (param_duplicate_folder_id) {
          try {
            let dupli = await getDocDataById(
              "folder",
              param_duplicate_folder_id
            );

            setNom(dupli.nom + " (Copie)");
            setVille(dupli.ville);
            setPostal(dupli.postal);
            setAdresse(dupli.adresse);
            setIntervention(dupli.intervention);
            setMission(dupli.pack_ref.id);
            setConductor(dupli.clientmember);
            setNum(dupli.num);
            setPrenom(dupli.prenom || "");
            setStructure(dupli.structure);
            setCollectifOptionsSelected(dupli.collectif_options || []);
            setAuditConfig({
              profil: dupli.audit_config?.profil || "",

              mpr: dupli.audit_config?.mpr || "",
              foyer_fiscal: dupli.audit_config?.foyer_fiscal || "",
            });
            setParticulierEmail(dupli.particulier?.email || "");
            setParticulierPhone(dupli.particulier?.phone || "");
            setMarque(dupli.marque || null);
            setTypeClient(
              dupli.partner_type === "particulier" ? "particulier" : "pro"
            );
            setClient(
              dupli.client_id === "particulier" ? null : dupli.client_id
            );
            setSelectedDateSeconds(
              dupli.datestring
                ? dayjs(dupli.datestring, "DD/MM/YYYY").unix()
                : null
            );
            setSelectedTime(
              dupli.hour && dupli.minute
                ? dayjs().hour(dupli.hour).minute(dupli.minute)
                : null
            );
            setFolderType(dupli.folder_type || firstPlan(masterData));
            setPaymentAllowed(dupli.payment_allowed || false);
            setUseFactureMat(dupli.use_facture_mat || false);
            setAddCarnet(dupli.add_carnet || false);
            setFolderData(dupli);
            setIntervention(dupli.intervention_realisee);
            setStructure(dupli.structure || "maison_individuelle");
          } catch (error) {
            console.error("Error fetching duplicate folder data:", error);
            handleClickVariant(
              "Erreur lors de la récupération du dossier à dupliquer",
              "error"
            );
          }
        }

        const endtime = new Date();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  const handleCheckFolderWithSameData = async () => {
    const filters = [
      {
        field: "master_id",
        operator: "==",
        value: orgData.id,
      },
      {
        field: "nom",
        operator: "==",
        value: nom,
      },
    ];
    const folders_with_same_data = await queryCollection("folder", filters);
    if (folders_with_same_data.length > 0) {
      handleClickVariant(
        "Attention - Un dossier avec " +
          "Nom : " +
          nom +
          " CP : " +
          folders_with_same_data[0].postal +
          " existe, il a été créé le " +
          getDateFromFlutter(
            folders_with_same_data[0].created_time
          ).toLocaleDateString(),
        "error"
      );
    }
  };

  const handleContinue = async () => {
    if (nom === "") {
      handleClickVariant("Veuillez saisir le nom du maître d'ouvrage", "error");
      return false;
    }
    if (prenom === "" && payment_allowed) {
      handleClickVariant(
        "Veuillez saisir le prénom du maître d'ouvrage",
        "error"
      );
      return false;
    }
    if (ville === "") {
      handleClickVariant("Veuillez saisir la ville", "error");
      return false;
    }
    if (postal === "") {
      handleClickVariant("Veuillez saisir le code postal", "error");
      return false;
    }
    if (typeof postal !== "string" || postal.length !== 5 || isNaN(postal)) {
      handleClickVariant("Le code postal est incorrect", "error");
      return false;
    }

    if (!intervention?.value === null) {
      handleClickVariant("Veuillez sélectionner l'intervention", "error");
      return false;
    }
    if (type_client === null) {
      handleClickVariant("Veuillez sélectionner le type de client", "error");
      return false;
    }
    if (type_client === "particulier" && particulier_email === "") {
      handleClickVariant("Veillez saisir l'email du particulier", "error");
      return false;
    }
    if (
      type_client === "particulier" &&
      !particulier_email.trim().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)
    ) {
      handleClickVariant("Veuillez saisir une adresse email valide.", "error");
      return false;
    }
    if (type_client === "particulier" && particulier_phone === "") {
      handleClickVariant("Veillez saisir le téléphone du particulier", "error");
      return false;
    }
    if (client === null && type_client === "pro") {
      handleClickVariant("Veuillez sélectionner le client", "error");
      return false;
    }

    if (
      folder_type === "audit" &&
      (!audit_config.profil || !audit_config.mpr || !audit_config.foyer_fiscal)
    ) {
      handleClickVariant(
        "Veuillez renseigner le profil, la catégorie MPR et le nombre de personnes dans le foyer fiscal pour l'audit",
        "error"
      );
      return false;
    }

    if (
      marque === null &&
      marques_options.length > 0 &&
      type_client === "pro"
    ) {
      handleClickVariant("Veuillez sélectionner la marque", "error");
      return false;
    }
    let clientData;
    if (type_client === "pro") {
      clientData = await getOrgById(client);
    } else {
      clientData = await getOrgById("particulier");
    }
    const filters = [
      {
        field: "master_id",
        operator: "==",
        value: orgData.id,
      },
      {
        field: "nom",
        operator: "==",
        value: nom,
      },
      {
        field: "postal",
        operator: "==",
        value: postal,
      },
      {
        field: "client_id",
        operator: "==",
        value: clientData.id,
      },
    ];
    const folders_with_same_data = await queryCollection("folder", filters);
    if (folders_with_same_data.length > 0) {
      handleClickVariant(
        "Un dossier avec les mêmes informations existe déjà",
        "error"
      );
      return false;
    }
  };

  useEffect(() => {
    if (currentUser) {
      handleFetchData(); // Fetch user data when currentUser is available
    }
  }, [currentUser]); // Dependency array ensures this runs when currentUser changes

  const theme = useTheme();

  const createFolder = async () => {
    if (!userData || !orgData) return;

    let can_continue = await handleContinue();

    if (can_continue === false) {
      return;
    }
    const client_id = type_client === "pro" ? client : "particulier";

    try {
      if (!mission || mission === "None") {
        handleClickVariant("Veuillez sélectionner la mission", "error");
        return;
      }

      setLoadingData(true);
      const oid = orgData.id; // Assuming orgData has the organization id
      const master_id = orgData.id; // Assuming client has the master
      const date = selectedDateSeconds ? dayjs.unix(selectedDateSeconds) : null;
      const datestring = date ? date.format("DD/MM/YYYY") : "../../....";
      const hour = selectedTime ? selectedTime.hour() : 0;
      const minute = selectedTime ? selectedTime.minute() : 0;

      let particulier = null;
      if (type_client === "particulier") {
        particulier = {
          email: particulier_email,
          phone: particulier_phone,
        };
      }

      // Get the user's Firebase authentication token
      const token = await currentUser.getIdToken(); // Fetch token from Firebas
      const packid = mission;
      const clientmemberid = conductor;

      const newFolderRef = await createNewFolder(
        token,
        prefix,
        payment_allowed,
        use_facture_mat,
        pack_options.find((p) => p.value === packid).extra_label ===
          "Pack basique"
          ? "basic"
          : folder_type,
        intervention,
        postal,
        adresse,
        mission,
        ville.trim(),
        nom.trim(),
        prenom.trim(),
        num.trim(),
        "",
        "",

        {
          email: "",
          phone: "",
          amount: 0,
          name: nom.trim(),
          postal: postal,
          city: ville.trim(),
          address: adresse,
        },
        clientmemberid,
        datestring,
        hour.toString(),
        minute,
        "../../....",
        "../../....",
        client_id,
        packid,
        structure,
        collectif_options_selected || [],
        master_id,
        oid,
        marque || "",
        particulier,
        audit_config,
        addCarnet
      );
      const folderData = await getDocDataByRef(newFolderRef);
      setFolderData(folderData);
      handleClickVariant("Dossier créé avec succès", "success");

      // client is client id
      await addClientPartners(folderData.id, client_id, token, prefix);
      await checkAndSendTriggerEvent(
        ["first_folder_created"],
        orgData,
        userData,
        prefix
      );
      handleClickVariant("Partenaires affiliés ajoutés", "success");
      setLoadingData(false);
      if (param_event_id) {
        let eventRef = getRefFromId("event", param_event_id);
        await updateDocDataFieldApi(
          eventRef,
          "folder",
          folderData.ref,

          prefix
        );
        navigateWorkspace("/planning");
      } else {
        Gleap.trackEvent("Folder created", {
          userId: userData.id,
        });
        // take a random
        let display_survey = Math.random() * 100 < 10;
        if (display_survey) {
          Gleap.showSurvey("960d3dca88a718db8576", "survey");
        }

        navigateWorkspace("/folder/" + folderData.id);
      }
    } catch (error) {
      console.error("Error creating folder:", error);
    }
  };
  // loading || !currentUser || !userData
  if (loading || !currentUser || !userData) {
    return (
      <div className="h-full w-c400 pl-4 flex flex-col gap-2">
        <SmallSpinner></SmallSpinner>
      </div>
    );
  }

  return (
    <div className="w-full  flex-row h-full overflow-auto flex pb-20">
      {/* Left Column: Takes all available space */}

      {/* Right Column: Fixed width */}
      {step === 0 && (
        <div className="h-fit pl-4 flex flex-col gap-2 w-full  pb-20">
          <div className="text-h1 font-semibold">Nouveau Dossier</div>
          <Space y={5} />
          <div className="h-fit max-w-c500 flex flex-col gap-2 w-full pr-2">
            <div className="flex flex-col gap-2 border-l-2 border-cyan-400 pl-2">
              <DropDownGPT03
                items={[
                  {
                    value: "pro",
                    label: "Client professionnel",
                  },
                  {
                    value: "particulier",
                    label: "Client particulier (autoconstructeur)",
                  },
                ]}
                className="w-full"
                label="Type de client"
                value={type_client}
                mandatory={true}
                onChange={(e) => {
                  setTypeClient(e.value);
                  if (e.value === "particulier") {
                    setPaymentAllowed(true);
                  }
                }} // Update state on change
              ></DropDownGPT03>
              {type_client === "particulier" && (
                <>
                  <TextField2T
                    className="w-full"
                    label="Email du particulier"
                    value={particulier_email}
                    onChange={(e) => setParticulierEmail(e.target.value)}
                    transparent={false}
                    mandatory={true}
                    type="email"
                  ></TextField2T>
                  <TextField2T
                    className="w-full"
                    label="Téléphone du particulier"
                    value={particulier_phone}
                    onChange={(e) => setParticulierPhone(e.target.value)}
                    transparent={false}
                    mandatory={true}
                    type="phone"
                  ></TextField2T>
                </>
              )}
              {type_client === "pro" && (
                <DropDownGPTS3
                  items={clients_name_options}
                  className="w-full"
                  label="Client"
                  value={client_text_value}
                  mandatory={true}
                  onChange={(e) => handleFetchClientConductors(e.value)} // Update state on change
                  resetValue={() => {
                    setClientTextValue(null);
                    setClient(null);
                  }}
                ></DropDownGPTS3>
              )}
              {type_client === "pro" && marques_options.length > 0 && (
                <DropDownGPT03
                  items={marques_options}
                  className="w-full"
                  label="Marque"
                  mandatory={true}
                  value={marque} // Controlled component
                  onChange={(e) => setMarque(e.value)} // Update state on change
                ></DropDownGPT03>
              )}
              <TextField2T
                className="w-full"
                label="Numéro de dossier"
                value={num}
                onChange={(e) => setNum(e.target.value)}
                transparent={false}
              ></TextField2T>
              <TextField2T
                className="w-full"
                label="Prénom du maître d'ouvrage"
                value={prenom}
                mandatory={payment_allowed}
                onChange={(e) => setPrenom(e.target.value)}
                transparent={false}
              ></TextField2T>
              <TextField2T
                className="w-full"
                label="Nom du maître d'ouvrage"
                value={nom}
                mandatory={true}
                onChange={(e) => setNom(e.target.value)}
                onFocusLost={handleCheckFolderWithSameData}
                transparent={false}
              ></TextField2T>
            </div>
            <div className="flex flex-col mt-6 gap-2 border-l-2 border-blue-400 pl-2 ">
              <DropDownGPTS3
                label="Ville"
                value={ville}
                mandatory={true}
                onChange={(e) => {
                  setVille(e.value);
                  fetchPostalCodes(e.value, true);
                }}
                active_filter_inculdes={false}
                onSearchChange={(value) => {
                  fetchPostalCodes(value);
                }}
                debounceDelay={500}
                loadingSearch={loadingSearch}
                transparent={false}
                allow_new_items={true}
                items={(() => {
                  // Always include the current ville value if it exists
                  const cities = [...citiesName];
                  if (ville && !cities.includes(ville)) {
                    cities.unshift(ville);
                  }
                  return cities.map((city) => ({
                    value: city,
                    label: city,
                  }));
                })()}
                add_item={(value) => {
                  setCitiesName([...citiesName, value]);
                  setVille(value);
                }}
              ></DropDownGPTS3>
              <DropDownGPTS3
                label="Code Postal"
                value={postal}
                allow_new_items={true}
                loadingSearch={loadingSearch}
                mandatory={true}
                onChange={(e) => {
                  console.log("Selected postal code:", e.value);
                  setPostal(e.value);
                }}
                onSearchChange={(value) => {
                  console.log("Typing postal code:", value);
                  updatePostalCodesItems(value);
                }}
                transparent={false}
                items={postalCodesItems}
                add_item={(value) => {
                  setPostalCodes([...postalCodes, value]);
                  setPostal(value);
                  updatePostalCodesItems(value);
                }}
              ></DropDownGPTS3>{" "}
              <TextField2T
                label="Adresse"
                value={adresse}
                mandatory={false}
                onChange={(e) => setAdresse(e.target.value)}
                transparent={false}
              ></TextField2T>
            </div>
            <div className="flex flex-col mt-6 gap-2  border-l-2 border-violet-400 pl-2 ">
              <DropDownGPT03
                items={structure_options}
                className="w-full"
                label="Structure"
                mandatory={false}
                value={structure} // Controlled component
                onChange={(e) => {
                  setStructure(e.value);
                  if (e.value === "collectif") {
                    setMission("Dn6JBn3U5MKsYfIAqjzs");
                  }
                }} // Update state on change
              ></DropDownGPT03>
              {folder_type === "infiltro" && (
                <>
                  <DropDownGPT03
                    items={intervention_options}
                    className="w-full"
                    label="Intervention à venir"
                    value={intervention} // Controlled component
                    onChange={(e) => setIntervention(e.value)} // Update state on change
                  ></DropDownGPT03>{" "}
                  <div className="h-fit w-full ">
                    <DatePickerGPT0
                      seconds={selectedDateSeconds}
                      locale={locale}
                      className="text-black "
                      onChange={setSelectedDateSeconds}
                      label="Sélectionner la date d'intervention"
                    />
                  </div>
                  {type_client === "pro" && (
                    <DropDownGPT03
                      items={client_conductors}
                      className="w-full"
                      label="Conducteur de chantier "
                      value={conductor}
                      onChange={(e) => setConductor(e.value)}
                    ></DropDownGPT03>
                  )}
                </>
              )}
              {folder_type === "audit" && (
                <>
                  <DropDownGPT03
                    items={audit_profil_options}
                    className="w-full"
                    label="Profil particulier"
                    value={audit_config.profil}
                    onChange={(e) =>
                      setAuditConfig({
                        ...audit_config,
                        profil: e.value,
                      })
                    }
                  ></DropDownGPT03>
                  <DropDownGPT03
                    items={audit_mpr_options}
                    className="w-full"
                    label="Catégorie MPR"
                    value={audit_config.mpr}
                    onChange={(e) =>
                      setAuditConfig({
                        ...audit_config,
                        mpr: e.value,
                      })
                    }
                  ></DropDownGPT03>
                  <TextField2T
                    label="Nombre de personnes dans le foyer fiscal"
                    value={audit_config.foyer_fiscal || ""}
                    mandatory={false}
                    onChange={(e) =>
                      setAuditConfig({
                        ...audit_config,
                        foyer_fiscal: e.target.value,
                      })
                    }
                    transparent={false}
                  ></TextField2T>
                </>
              )}

              <DropDownGPTS3
                items={pack_options}
                className="w-full"
                label="Prestation"
                display_redirect={true}
                useRedirect={(e) => {
                  navigateWorkspace("/packs");
                }}
                mandatory={true}
                value={mission} // Controlled component
                onChange={(e) => setMission(e.value)} // Update state on change
              ></DropDownGPTS3>
            </div>
            <div className="flex flex-col mt-6 gap-2">
              <ToggleSettingsBrick
                title="Utiliser le paiement particulier pour ce dossier"
                description={
                  "Les rapports seront automatiquement disponibles au client dès que le particulier aura payé."
                }
                disabled={type_client !== "pro"}
                checked={payment_allowed}
                onChange={(checked) => {
                  setPaymentAllowed(checked);
                }}
              ></ToggleSettingsBrick>
              {false && folder_type === "infiltro" && (
                <ToggleSettingsBrick
                  title="Utiliser une facture de matériaux au lieu d'ATH"
                  description={
                    "Nous avons modifié le fonctionnement relatif aux factures de matériaux. Si vous voulez utiliser une facture de matériaux, ajoutez ce document au niveau de la prestation. N'hésitez pas à nous envoyer un message si vous avez besoin d'aide."
                  }
                  disabled={true}
                  checked={use_facture_mat}
                  onChange={(checked) => {
                    setUseFactureMat(checked);
                  }}
                ></ToggleSettingsBrick>
              )}
              <ToggleLogementBrick
                title="Inclure un CIL"
                checked={addCarnet}
                onChange={(e) => {
                  setAddCarnet(e);
                }}
                description={
                  "Un carnet d'information du logement sera généré et synchronisé avec le dossier."
                }
                disabled={
                  !["se4um6hWlIVKiLxln3gB", "wmLGIwRMtQD2LLc6nXQf"].some(
                    (allowed) =>
                      orgData.id === allowed ||
                      orgData.masters_id?.includes(allowed)
                  )
                }
              ></ToggleLogementBrick>
            </div>
            <Space y={10} />
            <div className="w-full flex flex-row justify-end gap-2">
              <SecondaryButton
                disabled={loadingData}
                onClick={() => navigateWorkspace("/folders")}
              >
                Annuler
              </SecondaryButton>
              <PrimaryButton onClick={createFolder} disabled={loadingData}>
                <div className="flex flex-row content-center align-middle items-center">
                  Générer le dossier <Space x={5} />
                  <SmallSpinner loading={loadingData} margin={0} size={20} />
                </div>
              </PrimaryButton>
            </div>
          </div>{" "}
          <div> </div>
        </div>
      )}
    </div>
  );
}

export default NewFolder;

export async function handleFetchPacksBasedOnFolderType(
  setPack_options,
  masterData,
  setMission
) {
  // const packs_filters = [
  //   {
  //     field: "org_id",
  //     operator: "==",
  //     value: masterData.id,
  //   },
  // ];
  // let custom_packs = await queryCollection("pack", packs_filters);
  // custom_packs = custom_packs.filter((pack) => pack.admin_pack !== true);
  // const filters_admin = [
  //   {
  //     field: "admin_pack",
  //     operator: "==",
  //     value: true,
  //   },
  // ];
  // const packs_admin = await queryCollection("pack", filters_admin);
  // // lets order by pack_name
  // // remove duplicates
  // const all_packs = custom_packs.concat(packs_admin);
  // let type_packs = all_packs;

  // const packs = type_packs.sort((a, b) => {
  //   if (a.admin_pack !== b.admin_pack) {
  //     return a.admin_pack === true ? -1 : 1;
  //   }
  //   return a.pack_name.localeCompare(b.pack_name);
  // });

  // const packs_name = packs.map((pack) => {
  //   return {
  //     value: pack.id,
  //     label: pack.pack_name,
  //     extra_label: pack.admin_pack ? null : "Personalisée",
  //     type: "green",
  //     folder_type: pack.folder_type || "infiltro",
  //   };
  // });

  // const sorted_packs_name = packs_name.sort((a, b) =>
  //   a.label.localeCompare(b.label)
  // );

  const packs_basic_filters = [
    {
      field: "org_id",
      operator: "==",
      value: masterData.id,
    },
  ];
  let all_basic_packs = await queryCollection(
    "prestation",
    packs_basic_filters
  );

  // lets order by pack_name
  // remove duplicates

  const packsbasic_ = all_basic_packs.sort((a, b) => {
    return a.name.localeCompare(b.name);
  });

  const packs_basic_name = packsbasic_.map((pack) => {
    return {
      value: pack.id,
      label: pack.name,
      folder_type: pack.type,
    };
  });

  const sorted_packs_basic_name = packs_basic_name.sort((a, b) =>
    a.label.localeCompare(b.label)
  );

  setPack_options([...sorted_packs_basic_name]);
}

export const audit_profil_options = [
  { value: "proprietaire_occupant", label: "Propriétaire occupant" },
  { value: "proprietaire_bailleur", label: "Propriétaire bailleur" },
  { value: "locataire", label: "Locataire" },
  { value: "bailleur_social", label: "Bailleur social" },
  { value: "sci", label: "SCI" },
  { value: "autre", label: "Autre" },
];
export const audit_mpr_options = [
  { value: "tres_modeste", label: "Très modeste" },
  { value: "modeste", label: "Modeste" },
  { value: "intermediaire", label: "Intermédiaire" },
  { value: "superieure", label: "Supérieure" },
  { value: "autre", label: "Autre" },
];
